<svg
  viewBox="4 4 8 8"
  [ngClass]="{
    'h-5 w-5': size === 2,
    'h-6 w-6': size === 3
  }"
>
  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g
      id="Group-Copy"
      transform="translate(4.295444, 4.604157)"
      fill="currentColor"
      fill-rule="nonzero"
    >
      <path
        d="M1.61912392,3.08712961 L5.78998715,3.08712961 C6.6842046,3.08712961 7.40911107,2.39605211 7.40911107,1.54356481 C7.40911107,0.691077503 6.6842046,0 5.78998715,0 L1.61912392,0 C0.724906472,0 0,0.691077503 0,1.54356481 C0,2.39605211 0.724906472,3.08712961 1.61912392,3.08712961 Z M1.61912392,0.617425922 L5.78998715,0.617425922 C6.32651762,0.617425922 6.7614615,1.03207242 6.7614615,1.54356481 C6.7614615,2.05505719 6.32651762,2.46970369 5.78998715,2.46970369 L1.61912392,2.46970369 C1.08259345,2.46970369 0.647649587,2.05505719 0.647649587,1.54356481 C0.647649587,1.03207242 1.08259345,0.617425922 1.61912392,0.617425922 Z"
        id="Shape-Copy-20"
      ></path>
      <path
        d="M1.83745135,2.13685198 C2.08762004,2.13888594 2.31428875,1.98975367 2.4114368,1.75920941 C2.50858486,1.52866515 2.45700749,1.2622842 2.28082919,1.08466199 C2.10465088,0.907039785 1.83869956,0.853289683 1.60736972,0.948552441 C1.37603988,1.0438152 1.22505383,1.26925874 1.22505383,1.51943543 C1.22505383,1.85847446 1.49842318,2.13409557 1.83745135,2.13685198 L1.83745135,2.13685198 Z"
        id="Path-Copy-14"
      ></path>
      <path
        d="M5.78998714,3.70455553 L1.6191239,3.70455553 C0.724906454,3.70455553 0,4.39563305 0,5.24812034 C0,6.10060763 0.724906454,6.79168514 1.6191239,6.79168514 L5.78998714,6.79168514 C6.68420459,6.79168514 7.40911107,6.10060764 7.40911107,5.24812034 C7.40911107,4.39563304 6.68420459,3.70455553 5.78998714,3.70455553 L5.78998714,3.70455553 Z M5.78998714,6.17425922 L1.6191239,6.17425922 C1.08259342,6.17425922 0.647649538,5.75961272 0.647649538,5.24812034 C0.647649538,4.73662796 1.08259342,4.32198146 1.6191239,4.32198146 L5.78998714,4.32198146 C6.32651761,4.32198146 6.7614615,4.73662796 6.7614615,5.24812034 C6.7614615,5.75961272 6.32651761,6.17425922 5.78998714,6.17425922 L5.78998714,6.17425922 Z"
        id="Shape-Copy-21"
      ></path>
      <path
        d="M5.54392378,4.67774545 C5.2937551,4.6757115 5.06708639,4.82484377 4.96993833,5.05538803 C4.87279028,5.28593228 4.92436765,5.55231324 5.10054595,5.72993544 C5.27672426,5.90755765 5.54267558,5.96130775 5.77400542,5.86604499 C6.00533526,5.77078224 6.15632131,5.5453387 6.15632131,5.295162 C6.15632131,4.95612297 5.88295196,4.68050187 5.54392378,4.67774545 Z"
        id="Path-Copy-15"
      ></path>
    </g>
  </g>
</svg>
